import { IncomingMessage } from 'http'
import { TLSSocket } from 'tls'
import { Context } from '@nuxt/types'
import cookie from 'cookie'

import { authModule } from '@/store'
import { authCookieName } from '@/utils/auth'

export default async ({ $axios, $config, isDev, req, res }: Context) => {
  if (process.client || !$config.enableMagicLink) {
    return
  }

  const url = createUrlFromRequest(req)
  if (
    !url.pathname.endsWith('pro/features') ||
    !url.searchParams.has('authorize')
  ) {
    return
  }

  authModule.setTokens({
    accessToken: '',
    refreshToken: url.searchParams.get('authorize'),
  })
  await authModule.refresh()
  const { token, refreshToken } = authModule
  if (!token || !refreshToken) {
    throw new Error('Invalid auth tokens after refreshing')
  }
  $axios.setToken(token, 'Bearer')
  const expires = new Date()
  expires.setFullYear(expires.getFullYear() + 1)
  res.setHeader(
    'Set-Cookie',
    cookie.serialize(
      authCookieName,
      JSON.stringify({
        auth: {
          token,
          refreshToken,
        },
      }),
      { expires, secure: !isDev, path: '/' },
    ),
  )
}

/**
 * Creates a new `URL` object from the given HTTP request.
 *
 * @param req
 * @returns
 */
function createUrlFromRequest(req: IncomingMessage) {
  let protocol = 'http'
  if ((req.socket as TLSSocket).encrypted) {
    protocol = 'https'
  }

  const baseUrl = `${protocol}://${req.headers.host}`

  if (!req.url) {
    return new URL(baseUrl)
  }

  const parsedUrl = new URL(req.url, `${protocol}://${req.headers.host}`)
  return parsedUrl
}
